import { render, staticRenderFns } from "./UserLogo.vue?vue&type=template&id=1a77a8d9"
import script from "./UserLogo.vue?vue&type=script&lang=js"
export * from "./UserLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports